<template>
  <transition name="scroll-x-transition" appear>
      <!-- hide-on-scroll -->
    <v-app-bar
      fixed
      flat
      class="header pt-0 pt-sm-2"
      :class="{'black-95': isBlack}"
      :value="isVisible"
      >
      <v-row align="center" justify="start" class="px-0 px-sm-5" no-gutters>
        <v-col cols="4" class="py-4 shrink" :style="{lineHeight: '0'}">
          <ChapterButton />
        </v-col>
        <v-col cols="4" class="py-1 shrink text-no-wrap text-center circle-container">
          <router-link :to="{ path: '/'+ $language.current }" class="header-logo">
            <RedCircle class="red-circle"/>
            <CovidLogo class="covid-logo ml-3"/>
            <div v-if="isCMSLoggedInUser">PREVIEW FOR EDITORS</div>
          </router-link>
        </v-col>
        <v-col cols="4" class="caption py-1 text-truncate text-right">
          <HamburgerMenu :menuOpen="menuOpen" @menu:toggle="onMenuToggle" />
        </v-col>
      </v-row>
    </v-app-bar>
  </transition>
</template>

<script>
import HamburgerMenu from '@/atoms/HamburgerMenu'
import RedCircle from '@/atoms/RedCircle'
import ChapterButton from '@/atoms/ChapterButton'
import { Auth } from '@aws-amplify/auth'
import CovidLogo from '@/assets/svg/covid19-logo-extended.svg'

export default {
  name: 'Header',

  components: {
    HamburgerMenu,
    CovidLogo,
    RedCircle,
    ChapterButton
  },

  props: {
    menuOpen: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      isCMSLoggedInUser: false,
      directionTop: true
    }
  },

  computed: {
    isBlack () {
      return (this.$route.name !== 'Home' && this.$route.name !== 'Chapters' && this.$root.projectContentsOpen === false)
    },
    isVisible () {
      return this.$root.projectContentsOpen === true || this.directionTop === true
    }
  },

  created () {
    Auth.currentAuthenticatedUser().then(user => {
      this.isCMSLoggedInUser = true
      return ''
    }).catch(e => {
      this.isCMSLoggedInUser = false
    })
  },

  methods: {
    onMenuToggle () {
      this.$emit('menu:toggle')
      // ...
    }
  },

  watch: {
    '$root.chapterProgress' (currentValue, prevValue) {
      this.directionTop = (currentValue < prevValue) || currentValue < 0.5// && (currentValue < 2 || currentValue > 10)
    }
  }
}
</script>

<style scoped lang="scss">

.header {
  z-index: 6 !important;

  &.black-95 {
    background-color: #0e0e0e !important;
  }
}

.circle-container span {
  vertical-align: top;

  font-family: 'Barlow', sans-serif;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
}

.header-logo {
  line-height: 1.3;
}

.red-circle {
  display: none;

  @include breakpoint('sm-and-down') {
    display: block;
  }
}

.covid-logo {
  height: 15px;
  display: inline-block;

  @include breakpoint('sm-and-down') {
    display: none !important;
  }
}

strong {
  font-weight: 600;
}
</style>
